import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'

import FilterPagination from 'pages/parts/FilterPagination'
import ExpenseGroups from './ExpenseGroups'
import { httpOk, GET, DELETE } from 'helpers/api'
import { formatMoney, returnSign, formatDate, getCurrentChequeDate, chequeDates } from 'helpers/helpers'

function Rasxodlar() {
	const { t } = useTranslation()
	const date = new Date()

	const transactionTypes = [
		{ id: 'plus', name: t('income') },
		{ id: 'minus', name: t('expense') },
	]

	const [data, setData] = useState([])
	const [cashiers, setCashiers] = useState([])
	const [paymentPurposeTypes, setPaymentPurposeTypes] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [totalAmount, setTotalAmount] = useState(0)
	const [pagination, setPagination] = useState({ url: '/expenses', response: null })
	const [deleteModal, setDeleteModal] = useState({ show: false, item: null, note: '' })

	// Guruhlab / Ro'yxat — tanlov brauzerda saqlanadi.
	// Sukut bo'yicha GURUHLAB: sahifaning vazifasi chiqim nazorati, ya'ni
	// «qaysi guruhga qancha ketdi» birinchi savol. Aniq bitta yozuvni topish
	// (va o'chirish) uchun «Ro'yxat» rejimi butunligicha saqlangan.
	const [viewMode, setViewMode] = useState(() => {
		try { return localStorage.getItem('rasxod_view') === 'flat' ? 'flat' : 'grouped' } catch (e) { return 'grouped' }
	})
	// O'chirilgandan keyin guruhli ko'rinish ham yangilansin
	const [reloadKey, setReloadKey] = useState(0)

	function changeView(mode) {
		setViewMode(mode)
		try { localStorage.setItem('rasxod_view', mode) } catch (e) { }
	}

	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		created_by: null,
		payment_purpose_id: null,
		payment_type_id: null,
		transaction_type: null,
		dateType: null,
		page: 0,
		size: 20,
	}

	// `filterData` — oynada TANLANAYOTGANI (hali kuchga kirmagan)
	const [filterData, setFilterData] = useState(initialFilter)
	/* `appliedFilter` — «Қўллаш» bosilgandan keyin AMALDAGI filtr.
	   Guruhli ko'rinish (ExpenseGroups) aynan shunga qaraydi. Ilgari unga
	   `filterData` berilardi va u har bir tanlovda o'zi qayta yuklanardi —
	   ro'yxatni tuzatib, guruhli ko'rinish tuzatilmasa foyda bo'lmasdi. */
	const [appliedFilter, setAppliedFilter] = useState(initialFilter)

	/**
	 * ⚠️ `fd` — IXTIYORIY filtr. Berilmasa joriy holat olinadi.
	 *    «Тозалаш» uchun kerak: `setFilterData()` holatni SHU ZAHOTI
	 *    yangilamaydi (React keyingi renderda qo'yadi), shuning uchun yangi
	 *    qiymatlar to'g'ridan-to'g'ri uzatiladi — bo'lmasa eski filtr bilan
	 *    so'rov ketardi.
	 */
	async function searchWithFilter(fd) {
		const f = fd || filterData
		setAppliedFilter(f)          // guruhli ko'rinish ham AYNAN shu filtrni oladi
		var urlParams = ""

		if (f.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + f.start_date
		if (f.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + f.end_date
		if (f.created_by)
			urlParams += returnSign(urlParams) + 'created_by=' + f.created_by
		if (f.payment_purpose_id)
			urlParams += returnSign(urlParams) + 'payment_purpose_id=' + f.payment_purpose_id
		if (f.payment_type_id)
			urlParams += returnSign(urlParams) + 'payment_type_id=' + f.payment_type_id
		if (f.transaction_type)
			urlParams += returnSign(urlParams) + 'transaction_type=' + f.transaction_type
		urlParams += returnSign(urlParams) + 'page=' + (f.page ?? 0)
		urlParams += returnSign(urlParams) + 'size=' + (f.size ?? 20)

		const hasFilter = f.created_by || f.payment_purpose_id ||
			f.payment_type_id || f.transaction_type
		setFilterDataExist(!!hasFilter)

		const filterUrl = '/expenses' + urlParams
		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data.data ?? [])
			setTotalAmount(response.data.total_amount ?? 0)
			setPagination({ url: filterUrl, response: response.data })
		}

		setDropdownIsOpen(false)
	}

	function resetFilter() {
		const def = { ...initialFilter }
		setFilterData(def)
		/* ⚠️ Ilgari bu yerda faqat `setFilterData` turardi va qayta yuklashni
		   avtomat `useEffect` bajarardi. Endi filtr maydonlari dep ro'yxatidan
		   olib tashlandi («Қўллаш» kutilsin deb), shuning uchun tozalash
		   so'rovni O'ZI yuborishi shart — aks holda tugma ishlamay qolardi. */
		searchWithFilter(def)
	}

	function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, dateType: option.id })
	}

	/* Sahifalash — so'rovni O'ZI yuboradi (yashirin `useEffect` orqali emas) */
	async function paginate(page, size) {
		const f = { ...filterData, page: page - 1, size }
		setFilterData(f)
		searchWithFilter(f)
	}

	/* «Қўллаш» — filtr AYNAN shu yerda kuchga kiradi.
	   Sahifa 1-ga qaytariladi: 3-sahifada turib filtr qo'llansa natija
	   3-sahifadan boshlanib, jadval bo'sh chiqib qolardi. */
	function applyFilter() {
		const f = { ...filterData, page: 0 }
		setFilterData(f)
		searchWithFilter(f)
	}

	function deleteExpense(item) {
		setDeleteModal({ show: true, item, note: '' })
	}

	async function confirmDeleteExpense() {
		const { item, note } = deleteModal
		const response = await DELETE(`/expense/${item.id}`, { deleted_note: note }, { loader: true })
		if (httpOk(response)) {
			setDeleteModal({ show: false, item: null, note: '' })
			searchWithFilter()
			setReloadKey(k => k + 1)   // guruhli ko'rinish ham yangilansin
		}
	}

	async function getPaymentPurposeTypes() {
		const response = await GET('/helper/ppt-expense')
		if (httpOk(response)) setPaymentPurposeTypes(response.data)
	}

	async function getCashiers() {
		const response = await GET('/helper/cashiers')
		if (httpOk(response)) setCashiers(response.data)
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	/* ⚠️ YAGONA avtomat so'rov — sahifa ochilganda. Boshqa hamma so'rov ANIQ
	   chaqiriladi: «Қўллаш» (applyFilter), «Тозалаш» (resetFilter), sahifalash
	   (paginate).
	   Ilgari ikkinchi `useEffect` bor edi va uning dep ro'yxatida filtr
	   maydonlari turardi (sana, kassir, tur, to'lov turi, tranzaksiya) —
	   natijada har bir tanlov «Қўллаш» kutilmasdan darrov so'rov yuborardi,
	   ustiga ustak `searchWithFilter()` ichidagi `setDropdownIsOpen(false)`
	   oynani yopib qo'yar, ikkinchi filtrni tanlab bo'lmasdi. Uch filtr tanlab
	   «Қўллаш» bosilsa — 4 ta so'rov ketardi (2026-08-11). */
	useEffect(() => {
		getCashiers()
		getPaymentPurposeTypes()
		getPaymentTypes()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center h-100">
					{t('expenses_by_worker')} [{pagination?.response?.total ?? 0}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>

							<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
								{t('filter')}
							</Dropdown.Toggle>

							<Dropdown.Menu className="dropdown-filter">
								<div className="row">
									<div className="form-group col-md-6">
										<label>{t('cashier')}</label>
										<Select
											isClearable
											options={cashiers}
											value={cashiers.find(o => o.login === filterData.created_by) || null}
											onChange={(option) => setFilterData({ ...filterData, created_by: option ? option.login : null })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.login}
										/>
									</div>
									<div className="form-group col-md-6">
										<label>{t('type')}</label>
										<Select
											isClearable
											options={paymentPurposeTypes}
											value={paymentPurposeTypes.find(o => o.id === filterData.payment_purpose_id) || null}
											onChange={(option) => setFilterData({ ...filterData, payment_purpose_id: option ? option.id : null })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.id}
										/>
									</div>
									<div className="form-group col-md-6">
										<label>{t('payment_type')}</label>
										<Select
											isClearable
											options={paymentTypes}
											value={paymentTypes.find(o => o.id === filterData.payment_type_id) || null}
											onChange={(option) => setFilterData({ ...filterData, payment_type_id: option ? option.id : null })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.id}
										/>
									</div>
									<div className="form-group col-md-6">
										<label>{t('transaction_type')}</label>
										<Select
											isClearable
											options={transactionTypes}
											value={transactionTypes.find(o => o.id === filterData.transaction_type) || null}
											onChange={(option) => setFilterData({ ...filterData, transaction_type: option ? option.id : null })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.id}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-group col-md-4">
										<label>{t('period')}</label>
										<Select
											options={chequeDates}
											value={chequeDates.find(o => o.id === filterData.dateType) || null}
											onChange={(option) => selectChequeDates(option)}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(o) => o.name}
											getOptionValue={(o) => o.id}
										/>
									</div>
									<div className="form-group col-md-4">
										<label className="invisible">{t('period')}</label>
										<div className="calendar-input">
											<DatePicker
												className="form-control"
												dateFormat="dd.MM.yyyy"
												selected={filterData.start_date ? new Date(filterData.start_date) : ''}
												onChange={(d) => setFilterData({ ...filterData, start_date: formatDate(d, 'yyyy-MM-dd') })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
									<div className="form-group col-md-4">
										<label className="invisible">.</label>
										<div className="calendar-input">
											<DatePicker
												className="form-control"
												dateFormat="dd.MM.yyyy"
												selected={filterData.end_date ? new Date(filterData.end_date) : ''}
												onChange={(d) => setFilterData({ ...filterData, end_date: formatDate(d, 'yyyy-MM-dd') })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-md-12 d-flex justify-content-end gap-2">
										<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>
											{t('cancel')}
										</button>
										<button className="btn btn-primary" onClick={() => applyFilter()}>
											{t('apply')}
										</button>
									</div>
								</div>
							</Dropdown.Menu>
						</Dropdown>

						<div className="vertical-center d-flex gap-3 align-items-center">
							{/* Guruhlab / Ro'yxat */}
							<div className="btn-group" role="group">
								<button type="button"
									className={'btn btn-sm ' + (viewMode === 'grouped' ? 'btn-primary' : 'btn-outline-primary')}
									onClick={() => changeView('grouped')}>
									<i className="uil-list-ui-alt me-1" />{t('pl_by_group')}
								</button>
								<button type="button"
									className={'btn btn-sm ' + (viewMode === 'flat' ? 'btn-primary' : 'btn-outline-primary')}
									onClick={() => changeView('flat')}>
									<i className="uil-align-left me-1" />{t('pl_flat_list')}
								</button>
							</div>
							<h5 className="mb-0">
								{t('total')}: <span className="text-danger fw-bold">{formatMoney(totalAmount)}</span>
							</h5>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.created_by &&
									<span className="me-2">
										<b>{t('cashier')}: </b>
										{cashiers.find(o => o.login === filterData.created_by)?.name}
									</span>
								}
								{filterData.payment_purpose_id &&
									<span className="me-2">
										<b>{t('type')}: </b>
										{paymentPurposeTypes.find(o => o.id === filterData.payment_purpose_id)?.name}
									</span>
								}
								{filterData.payment_type_id &&
									<span className="me-2">
										<b>{t('payment_type')}: </b>
										{paymentTypes.find(o => o.id === filterData.payment_type_id)?.name}
									</span>
								}
								{filterData.transaction_type &&
									<span className="me-2">
										<b>{t('transaction_type')}: </b>
										{transactionTypes.find(o => o.id === filterData.transaction_type)?.name}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					{/* Guruhli ko'rinishga AMALDAGI filtr beriladi — tanlanayotgani emas,
					    aks holda u «Қўллаш» ni kutmay o'zi qayta yuklanardi */}
					{viewMode === 'grouped' ? (
					<ExpenseGroups filterData={appliedFilter} onDelete={deleteExpense} reloadKey={reloadKey} />
					) : (
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th style={{ width: '10%' }}>{t('cashier')}</th>
									<th style={{ width: '13%' }}>{t('type')}</th>
									<th style={{ width: '10%' }}>{t('payment_type')}</th>
									<th style={{ width: '10%' }}>{t('account')}</th>
									<th style={{ width: '10%' }}>{t('counterparty')}</th>
									<th style={{ width: '17%' }}>{t('note')}</th>
									<th style={{ width: '12%' }} className="text-center">{t('date')}</th>
									<th style={{ width: '10%' }} className="text-end">{t('amount')}</th>
									<th style={{ minWidth: '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.length === 0 ? (
									<tr>
										<td colSpan="10" className="text-center text-muted py-4">{t('list_empty')}</td>
									</tr>
								) : (
									data.map((item, index) => (
										<tr key={index}>
											<td className="text-center">{(filterData.page * filterData.size) + index + 1}</td>
											<td className="td-ellipsis">{item.created_by}</td>
											<td className="td-ellipsis">{item.name}</td>
											<td className="td-ellipsis">{item.payment_name}</td>
											<td className="td-ellipsis">{item.account_name ?? '—'}</td>
											<td className="td-ellipsis">{item.client_name}</td>
											<td className="td-ellipsis" title={item.note}>{item.note}</td>
											<td className="text-center text-nowrap">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
											<td className={`text-end ${item.transaction_type === 'plus' ? 'text-success' : 'text-danger'}`}>
												{formatMoney(item.amount)}
											</td>
											<td className="text-center">
												<i className="uil-trash text-danger cursor" style={{ fontSize: '16px' }}
													onClick={() => deleteExpense(item)} />
											</td>
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>
					)}

					{viewMode === 'flat' && pagination.response &&
						<FilterPagination pagination={pagination} paginate={paginate} />
					}
				</div>
			</div>

			<Modal show={deleteModal.show} onHide={() => setDeleteModal({ show: false, item: null, note: '' })} centered>
				<Modal.Header closeButton>
					<Modal.Title>{t('delete')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">
						<b>{deleteModal.item?.name}</b> — {formatMoney(deleteModal.item?.amount)} so'm
					</div>
					<label className="form-label">{t('delete_note')} <span className="text-danger">*</span></label>
					<textarea
						className="form-control"
						rows={3}
						value={deleteModal.note}
						onChange={e => setDeleteModal(prev => ({ ...prev, note: e.target.value }))}
						placeholder={t('delete_note')}
					/>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-secondary" onClick={() => setDeleteModal({ show: false, item: null, note: '' })}>
						{t('cancel')}
					</button>
					<button
						className="btn btn-danger"
						disabled={!deleteModal.note?.trim()}
						onClick={confirmDeleteExpense}
					>
						{t('delete')}
					</button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default Rasxodlar
